import React, {Component} from 'react';
import './introduction.css';
import Avatar from 'material-ui/Avatar';


class IntroductionComponent extends Component {
    render() {
        return (
          <div className="introduction">
            <Avatar src="avatar.jpg" size={150}/>
            <p className="introduction-text">
              Loves Javascript, cat videos,memes and my wife.
              Professional Chicken-Eater. Defender of peace.
              SQA/SDET, currently living in Gurugram, India.
            </p>
          </div>
        );
    }
}

export default IntroductionComponent;



// WEBPACK FOOTER //
// ./src/components/introduction/introduction.jsx